<script setup>

</script>
<template><div class="r-table-row r-table-header"><slot></slot></div>
</template>